import * as React from 'react';

import { reduceStyles } from '@/helpers';
import { PressableProps } from './model';

const Pressable: React.FC<PressableProps> = ({
	activeOpacity = 1,
	children,
	disabled,
	onPress,
	onPressIn,
	onPressOut,
	style,
}) => {
	const [isPressed, setIsPressed] = React.useState(false);

	const _onPressIn = () => {
		setIsPressed(true);
		onPressIn && onPressIn();
	};

	const _onPressOut = () => {
		setIsPressed(false);
		onPressOut && onPressOut();
	};

	const styleObject = reduceStyles([{ cursor: 'pointer', opacity: isPressed ? activeOpacity : 1 }, style] as object);

	return (
		<div
			onClick={!disabled ? onPress : undefined}
			onMouseDown={!disabled ? _onPressIn : undefined}
			onMouseUp={!disabled ? _onPressOut : undefined}
			style={styleObject as React.CSSProperties}
		>
			{children}
		</div>
	);
};

export default Pressable;
